import Game from '../../../Game';
import GameObject from '../../../GameObject/GameObject';
import AnimationClip from '../AnimationClip';
import { Easing } from '@tweenjs/tween.js';
import Renderable from '../../../Component/Renderable';
import Element from '../../../Prototype/UI/Element';
import ElementComponent from '../../../Component/UI/Element';
import { delay } from '../../../Utility/Task/TaskQueue';
import UITextComponent from '../../../Component/UI/Text';
import { AwaitIterators } from '../AnimationHelper';

const TXT_BANNER: string = 'main_container/banner/banner_text';
const WORLD_SCORE: string = 'main_container/world_score';
const TXT_STARS: string = `${WORLD_SCORE}/star_container/text`;
const TXT_CHESTS: string = `${WORLD_SCORE}/chest_container/text`;
const TXT_CARDS: string = `${WORLD_SCORE}/card_container/text`;

export class TravelMenu extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta: {
            direction: string;
            title: string;
            stars: string;
            chests: string;
            cards: string;
        }
    ): IterableIterator<number> {
        if (meta.direction && meta.direction != 'none') {
            const iterators = [this.fadeValues(gameObject, meta)];
            yield* AwaitIterators(iterators);
        }

        while (true) yield;
    }

    private *fadeValues(gameObject: GameObject, meta: any) {
        const title = gameObject.find(TXT_BANNER);
        this.alpha(title, 1, 0);
        const scores = gameObject.find(WORLD_SCORE);
        this.alpha(scores, 1, 0);

        yield* delay(300);

        this.swapTexts(gameObject, meta);

        this.alpha(title, 0, 1);
        this.alpha(scores, 0, 1);

        yield* delay(100);
    }

    private swapTexts(gameObject: GameObject, meta?: any): void {
        gameObject
            .find(TXT_BANNER)
            .getComponent(UITextComponent).text = Game.locale.getText(
            meta.title
        );

        gameObject.find(TXT_STARS).getComponent(UITextComponent).text =
            meta.stars;

        gameObject.find(TXT_CHESTS).getComponent(UITextComponent).text =
            meta.chests;

        gameObject.find(TXT_CARDS).getComponent(UITextComponent).text =
            meta.cards;
    }

    private alpha(gameObject: GameObject, start: number, end: number) {
        const renderable = gameObject.getComponent(Renderable);
        renderable.alpha = start;

        const alphaTween = this.getTween(renderable);
        alphaTween
            .to({ alpha: end }, 300)
            .easing(Easing.Linear.None)
            .start(this.elapsedTime);
    }
}
